import type { ReactElement } from 'react';
import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { usePDPContext } from '~/utilities/context/static/PDPContext';
import { SiteType } from '~/utilities/graphql/codegen';

const GstarIconReturns = css`
  line-height: 1.4;
  display: flex;
  align-items: center;
  padding-left: ${({ theme }) => theme.padding.md};

  &::before {
    content: '${'\\F185'}';
    font-family: gstar-icons;
    font-style: normal;
    font-size: ${({ theme }) => theme.font.size[4]};
    position: absolute;
    left: 0;
  }
`;

const AafIconReturns = css``;

const IconReturnsConfig: Record<SiteType, RuleSet> = {
  [SiteType.Gstar]: GstarIconReturns,
  [SiteType.Wahts]: GstarIconReturns,
  [SiteType.Outlet]: GstarIconReturns,
  [SiteType.Employeeshop]: GstarIconReturns,
  [SiteType.Aaf]: AafIconReturns,
};

const S = {
  Label: styled.p`
    font-size: ${({ theme }) => theme.font.size[2]};
    font-weight: ${({ theme }) => theme.variables.font.weight.regular};
    line-height: 12px;
    position: relative;
    color: ${({ theme }) => theme.colors.content.primary};
    ${({ theme }) => IconReturnsConfig[theme.siteType]};
  `,
};

export const ProductReturnFees = (): ReactElement => {
  const {
    product: { pdpReturnPolicyUspMessage },
  } = usePDPContext();

  return pdpReturnPolicyUspMessage ? (
    <S.Label
      data-testid="product-return-policy-text"
      dangerouslySetInnerHTML={{ __html: pdpReturnPolicyUspMessage }}
    />
  ) : (
    <></>
  );
};
